import { createComponentHealth } from '@shared/components/ComponentHealth';

export const [wrapWithCurationsIndexHealthProvider, useCurationsIndexHealth] = createComponentHealth('CurationsIndex');
